import CouponIcon from 'assets/icons/coupon.svg';
import React from 'react';

import { Box, Divider, Grid, Stack, Typography, useTheme } from '@mui/material';

interface Props {
  couponName: string;
}

export const TutorPlanOrderResumeDiscount: React.FC<Props> = ({
  couponName,
}) => {
  const {
    palette: { primary },
  } = useTheme();

  if (!couponName) {
    return null;
  }

  return (
    <>
      <Grid item mx={1}>
        <Divider
          orientation="vertical"
          sx={{ backgroundColor: primary.main }}
        />
      </Grid>
      <Grid
        item
        container
        xs={12}
        md={3}
        spacing={2}
        justifyContent="center"
        alignItems="center"
        mt={0.5}
      >
        <Stack justifyContent="center" alignItems="center">
          <Box
            component="img"
            alt="Ícone cupom"
            src={CouponIcon}
            width={34}
            height={26}
            mb={1}
          />

          <Typography color="#000000" fontSize={16} fontWeight={500}>
            {couponName}
          </Typography>

          <Typography color="#4B4B4B" fontSize={14} fontWeight={400}>
            Cupom aplicado
          </Typography>
        </Stack>
      </Grid>
    </>
  );
};
